import { TabTypes } from '@ibinder/common-utils';

export const BINDERCOLORS = [
  '#314F6F',
  '#E1D631',
  '#D20000',
  '#638860',
  '#F5F2EC',
  '#7799C3',
  '#003471',
  '#8B438B',
  '#D27261',
  '#D59E68',
  '#8B8B8B',
  '#B5B5B5',
  '#7F6751',
  '#F04E91'
];
export const ApplicationTabs = [
  TabTypes.Announcements,
  TabTypes.Inspections,
  TabTypes.CaseManagement,
  TabTypes.QuestionsAndAnswers
];
export enum TabGroup {
  List = 'list',
  Structure = 'structure',
  Application = 'application'
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export enum TAB_SETTINGS {
  TEMPLATE_ID = 'tabTemplateId',
  ORIGIN_TAB_TEMPLATE_ID = 'originTabTemplateId',
  DOCUMENT_VERSION_STARTER = 'DocumentVersionStarter',
  DEFAULT_NAVIGATION_TAB = 'defaultNavigationTab'
}

export enum saveStatus {
  SAVED = 'saved',
  UNSAVED = 'unsaved'
}

export enum BinderTemplateStates {
  EDIT_ABOUT_TEMPLATE = 'editAboutBinderTemplate',
  EDIT_TABS = 'editBinderTemplateTabs',
  VIEW_TEMPLATE = 'viewBinderTemplate',
  EDIT_USERS_AND_ROLES = 'editUsersAndRoles'
}

interface BinderTabTemplate {
  id: string;
  country: string;
  name: string;
  shortName: string;
  translationKey: string;
  type: string;
  alwaysActive: boolean;
  defaultActive: boolean;
  positionLocked: boolean;
  binderRoleType: boolean;
  settings: boolean;
  metadataRequiredForUpload: any[];
  metadataUsedForFilter: any[];
  metadataUsedForDisplay: any[];
  groupByMetadataElementId: string;
  tenantSpecific: boolean;
  securityContext: any;
}
interface BaseTabSettings {
  tabTemplateId?: string;
  inLineTabTemplate?: BinderTabTemplate;
  name: string;
  shortName: string;
  translationKey?: string;
  defaultActive: boolean;
  alwaysActive: boolean;
  positionLocked: boolean;
  tenantSpecific?: boolean;
  tempInLineTabTemplate?: BinderTabTemplate;
  sortOrder: number;
  internalId?: string;
  status?: saveStatus;
  expanded?: boolean;
  isNewTab?: boolean;
  settings?: any;
  securityContext?: any;
}
interface ApiTab {
  legacyBinderId?: string;
  sortOrder: number;
  positionLocked: boolean;
  active: boolean;
  alwaysActive: boolean;
  id: string;
  name: string;
  shortName?: string;
  translationKey?: string;
  hasData?: boolean;
  type?: string;
  metadataRequiredForUpload?: any[];
  metadataUsedForFilter?: any[];
  metadataUsedForDisplay?: any[];
  settings?: any[];
  subTabs: Tab[];
  groupByMetadataElementId?: string;
  securityContext?: any;
}
export interface Tab extends ApiTab {
  originalName: string;
  expanded: boolean;
  defaultActive: boolean;
  subtabSettings?: any[];
  tabTemplateId?: string;
  isNewTab?: boolean;
}
export interface BinderTemplate {
  id?: string;
  country?: string;
  name: string;
  description: string;
  binderType: string;
  defaultColor: string;
  colorLocked: boolean;
  defaultLogo?: { name: string; url: string; documentId: string };
  logoLocked: boolean;
  binderMetadataElements: [];
  participants: object[];
  tabs: BaseTabSettings[];
  assignableRoleTypes: { id: string; name: string }[];
  tenantSpecific: boolean;
}

export const EMPTY_TEMPLATE: BinderTemplate = {
  name: '',
  binderType: '',
  description: '',
  defaultColor: BINDERCOLORS[0],
  colorLocked: false,
  defaultLogo: null,
  logoLocked: false,
  participants: [],
  tabs: [],
  tenantSpecific: true,
  binderMetadataElements: [],
  assignableRoleTypes: []
};
